import { AppError, StoreFn } from "../../types";

export const buy: StoreFn<number> = async (actions, amount, helpers) => {
  const app = helpers.injections.AppService;
  try {
    await app?.buy(amount);
  } catch (e: any) {
    console.info("eee", e, amount);
    if (e.message === AppError.UserDeniedTransaction) {
      actions.setErrors([AppError.UserDeniedTransaction]);
    }
  }
};
